export default __webpack_public_path__ + "static/media/body-spa.b6917705.jpg";